import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/admin/reset-password`,
      });
      if (error) throw error;
      setSent(true);
      toast.success("Nollauslinkki lähetetty sähköpostiisi.");
    } catch (err: any) {
      toast.error(err.message || "Lähetys epäonnistui");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/20 p-4">
      <div className="w-full max-w-sm rounded-2xl border bg-card p-8 shadow-sm">
        <h1 className="mb-4 font-display text-2xl font-semibold">Unohditko salasanan?</h1>
        {sent ? (
          <p className="text-sm text-muted-foreground">
            Lähetimme nollauslinkin osoitteeseen <strong>{email}</strong>. Tarkista sähköpostisi
            (myös roskaposti).
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Sähköposti</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full">
              {loading ? "Lähetetään..." : "Lähetä nollauslinkki"}
            </Button>
          </form>
        )}
        <Link
          to="/admin/login"
          className="mt-4 block text-center text-sm text-muted-foreground hover:text-foreground"
        >
          Takaisin kirjautumiseen
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
